<template>
    <div class="hamburguer d-print-none">
        <div class="hamburguer-principal d-flex">
            <button class="navbar-toggler collapsed ms-2 mt-2" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
                <span class="navbar-toggler-icon">☰</span>
            </button>

            <p class="clienteNome fs-4 w-50"> {{ $store?.state?.config?.clienteNome }}
                <span v-show="nomeTela?.length > 0"> - </span> {{ nomeTela }}
            </p>

            <img src="@/assets/img/Identidade-Visual.png" class="logo me-2 mt-1" alt="">
        </div>
    </div>


    <div class="collapse show d-print-none" id="collapseExample">
        <!-- <div v-if="nomeTela" class="hamburguer-principal meuCollapse d-flex">
            <p class="clienteNome nomeTela m-0"> {{ nomeTela }} </p>atualizacao
            <span class="logo me-2"></span>
        </div> -->
        <div class="card card-body meuCollapse d-flex pt-1 pb-2">

            <div class="d-flex flex-column">
                <div class="links">
                    <RouterLink to="/" class="nav-link abertos" v-if="usarAberto">
                        <p> Aberto </p>
                    </RouterLink>
                    <RouterLink to="/historico" class="nav-link historico" v-if="usarHistorico">
                        <p> Historico </p>
                    </RouterLink>
                    <RouterLink to="/gerenciar" class="nav-link historico" v-if="usarGerenciar && token">
                        <p> Gerenciar </p>
                    </RouterLink>
                    <RouterLink to="/internacao" class="nav-link historico" v-if="usarInternacao && token">
                        <p> Internação </p>
                    </RouterLink>
                    <RouterLink to="/GerenciarRelatorios" class="nav-link historico" v-if="usarRelatorio === true && token">
                        <p> Relatório </p>
                    </RouterLink>
                    <button class="nav-link historico" @click="voltar" v-if="usarVoltar">
                        Voltar
                    </button>
                    <button class="nav-link historico" @click="deslogar" v-if="usarDeslogar === true && token">
                        Deslogar
                    </button>
                    <RouterLink to="/login" class="nav-link historico" v-if="usarDeslogar === true && !token">
                        <p> Login </p>
                    </RouterLink>
                </div>
            </div>
            <div class="d-flex flex-column" v-if="usarFiltros">
                <div>
                    <div class="d-flex mainFiltros"
                        v-if="usarFiltroPosicao === true || usarTrocaVisualizacao === true || usarFiltroSetor == true || usarFiltroTpChamado === true || usarFiltroPosicao === true || usarFiltroDatas === true || usarTrocaVisualizacao === true">
                        <div class="filtros"
                            v-if="usarFiltroSetor == true || usarFiltroTpChamado === true || usarFiltroPosicao === true || usarFiltroDatas === true || usarTrocaVisualizacao === true">
                            <div v-if="usarFiltroDatas">
                                <div class="divChamado">
                                    <label for="dataInicial" class="lblTelaMenor chamado">
                                        <p>Data Inicial</p>
                                    </label>
                                    <input type="date" class="form-select form-chamado" name="dataInicial" id="dataInicial"
                                        style="background-image: none; padding: 0.375rem 0.63rem .375rem .75rem;"
                                        v-model="state.dataInicial" @change="resetarTela()">
                                </div>
                                <div class="divChamado dataFinalCelular"
                                    v-if="principal != true && usarFiltroDatas == true">
                                    <label for="dataFinalCelular" class="lblTelaMenor chamado">
                                        <p>Data Final</p>
                                    </label>
                                    <input type="date" class="form-select form-chamado" name="dataFinalCelular"
                                        id="dataFinalCelular"
                                        style="background-image: none; padding: .375rem 0.63rem .375rem .75rem;"
                                        v-model="state.dataFinal" @change="resetarTela()">
                                </div>

                                <div class="divSetor" v-if="usarFiltroSetor" style="margin-top: 0.3%;">
                                    <label for="setor" class="lblTelaMenor chamado">
                                        <p>Setor</p>
                                    </label>
                                    <select name="setor" id="setor" class="form-select form-chamado"
                                        v-model="state.valorFiltroSetor" @change="resetarTela()">
                                        <option value="0">Todos</option>
                                        <option v-for="setor in setores" :key="setor.id" :value="setor.id">
                                            {{ setor.descricao }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div class="divChamado dataFinalGrande margem1"
                                    v-if="principal != true && usarFiltroDatas == true">
                                    <label for="dataFinalGrande" class="lblTelaMenor chamado">
                                        <p>Data Final</p>
                                    </label>
                                    <input type="date" class="form-select form-chamado" name="dataFinalGrande"
                                        id="dataFinalGrande"
                                        style="background-image: none;  padding: .375rem 0.63rem .375rem .75rem;"
                                        v-model="state.dataFinal" @change="resetarTela()">
                                </div>

                                <div class="divSetor divSetorPrincipal" v-if="usarFiltroSetor && principal">
                                    <label for="setor" class="lblTelaMenor chamado">
                                        <p>Setor</p>
                                    </label>
                                    <select name="setor" id="setor" class="form-select form-chamado"
                                        v-model="state.valorFiltroSetor" @change="resetarTela(), filtrar(false)">
                                        <option value="0">Todos</option>
                                        <option v-for="setor in setores" :key="setor.id" :value="setor.id">
                                            {{ setor.descricao }}
                                        </option>
                                    </select>
                                </div>

                                <div class="divChamado margem1 divChamadoPrincipal" v-if="usarFiltroTpChamado"
                                    style="margin-top: 0.3%">
                                    <label for="tipoChamado" class="lblTelaMenor chamado">
                                        <p>Chamado</p>
                                    </label>
                                    <select name="tipoChamado" id="tipoChamado" class="form-select form-chamado"
                                        v-model="state.valorFiltroTPChamado" @change="resetarTela(), filtrar(false)">
                                        <option value="0">Todos</option>
                                        <FiltroTipoChamado v-for="tpChamado in $store.state.tipoChamado" :key="tpChamado.id"
                                            :value="tpChamado.id" :tpChamado="tpChamado" />
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="filtros" v-if="(principal != true && usarFiltroDatas == true) ||
                            (usarTrocaVisualizacao === true) ||
                            (usarFiltroPosicaoAuxiliar || usarFiltroTempo || usarFiltroPosicao) ||
                            (relatorios)
                            ">
                            <div class="divChamado dataFinalPequeno margem1"
                                v-if="principal != true && usarFiltroDatas == true">
                                <label for="dataFinalPequeno" class="lblTelaMenor chamado">
                                    <p>Data Final</p>
                                </label>
                                <input type="date" class="form-select form-chamado" name="dataFinalPequeno"
                                    id="dataFinalPequeno"
                                    style="background-image: none;  padding: .375rem 0.63rem .375rem .75rem;"
                                    v-model="state.dataFinal" @change="resetarTela()">
                            </div>
                            <div v-if="usarTrocaVisualizacao === true">
                                <div class="divChamado divVisualizacao margem2" v-if="usarTrocaVisualizacao">
                                    <label for="visualizacao" class="lblTelaMenor chamado">
                                        <p>Visualização</p>
                                    </label>
                                    <select name="visualizacao" id="visualizacao" class="form-select form-chamado"
                                        v-model="state.valorVisualizacao" @change="resetarTela()">
                                        <option v-show="card && state.historico == true" :value="'Card'">Card</option>
                                        <option v-show="grafico && state.historico == false" :value="'Grafico'">Gráfico
                                        </option>
                                        <option v-show="tabela" :value="'Tabela'"> Tabela</option>
                                    </select>
                                </div>
                                <div class="divChamado margem2" v-if="usarAlterarRelatorio" style="margin-top: 0.3%">
                                    <label for="relatorios" class="lblTelaMenor chamado">
                                        <p>Relatórios</p>
                                    </label>
                                    <select name="relatorios" id="relatorios" class="form-select form-chamado"
                                        v-model="state.historico" @change="resetarTela()">
                                        <option :value="false"> Gráficos </option>
                                        <option :value="true">Histórico Geral</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="usarFiltroPosicaoAuxiliar || usarFiltroTempo || usarFiltroPosicao">
                                <div class="divChamado divPosicaoGrande margem3" v-if="usarFiltroTempo">
                                    <label for="duracao" class="lblTelaMenor chamado">
                                        <p>Duração</p>
                                    </label>
                                    <select name="duracao" id="duracao" class="form-select form-chamado"
                                        v-model="state.valorDuracao" @change="resetarTela()">
                                        <option :value="`0`"> Todos </option>
                                        <option :value="`1 and 1800`"> Até 30m </option>
                                        <option :value="`1800 and 3600`"> 30m até 1h </option>
                                        <option :value="`3600 and 4800`"> 1h até 1h 20m </option>
                                        <option :value="`4800 and 6000`"> 1h 20m até 1h 40m </option>
                                        <option :value="`6000 and 7200`"> 1h 40m até 2h </option>
                                        <option :value="`1`"> 2h ou mais</option>
                                    </select>
                                </div>
                            </div>
                            <div class="btnGerarGrande">
                                <div class="divGerar" style="margin-left: 20%;" v-if="relatorios">
                                    <div class="botaoGerar" v-if="relatorios">
                                        <button @click="filtrar(true)" class="btn-filtrar"
                                            style="height: 40px;">Gerar</button>
                                    </div>
                                </div>
                                <div class="divGerar" style="margin-left: 20%; margin-top: 1.3%;"
                                    v-if="relatorios && usarExportacao">
                                    <div class="botaoGerar" v-if="relatorios && usarExportacao">
                                        <button @click="abrirModalExportacao()" class="btn-filtrar"
                                            style="height: 40px;">Exportar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mainFiltros" v-if="usarFiltroPosicao || usarFiltroTempo">
                        <div class="filtros" v-if="usarFiltroPosicao || usarFiltroTempo">
                            <div class="divChamado posicaoGrande" style="margin-top: 0.3%;" v-if="usarFiltroPosicao">
                                <!-- style="max-width: 700px" -->
                                <label for="posicao" class="lblTelaMenor chamado" style="max-width: 130px;"> <!--   -->
                                    <p>Posição</p>
                                </label>
                                <div class="form-select " name="posicao" id="posicao"
                                    style="background-image: none; padding: .375rem 0.63rem .375rem .75rem;">
                                    <!-- width: 550px; -->
                                    <div class="d-flex justify-content-between">
                                        <label class="form-check" for="inpAberto"> Aberto
                                            <input v-model="state.usarPosicaoAberto" id="inpAberto" class="form-check-input"
                                                type="checkbox">
                                        </label>

                                        <label class="form-check" for="inpAdministrativo" v-show="state.historico">
                                            Administrativo
                                            <input v-model="state.usarPosicaoAdministrativo" id="inpAdministrativo"
                                                class="form-check-input" type="checkbox">
                                        </label>

                                        <label class="form-check" for="inpFechado"> Fechado
                                            <input v-model="state.usarPosicaoFechado" id="inpFechado"
                                                class="form-check-input" type="checkbox">
                                        </label>

                                        <label class="form-check" for="inpCancelado"> Cancelado
                                            <input v-model="state.usarPosicaoCancelado" id="inpCancelado"
                                                class="form-check-input" type="checkbox">
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="divChamado divPosicaoPequeno margem3" v-if="usarFiltroTempo"
                                style="margin-top: 0.3%;">
                                <label for="duracao" class="lblTelaMenor chamado">
                                    <p>Duração</p>
                                </label>
                                <select name="duracao" id="duracao" class="form-select form-chamado"
                                    v-model="state.valorDuracao" @change="resetarTela()">
                                    <option :value="`0`"> Todos </option>
                                    <option :value="`1 and 1800`"> Até 30m </option>
                                    <option :value="`1800 and 3600`"> 30m até 1h </option>
                                    <option :value="`3600 and 4800`"> 1h até 1h 20m </option>
                                    <option :value="`4800 and 6000`"> 1h 20m até 1h 40m </option>
                                    <option :value="`6000 and 7200`"> 1h 40m até 2h </option>
                                    <option :value="`1`"> 2h ou mais</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btnGerarPequeno">
                    <div class="divGerar" v-if="relatorios">
                        <div class="botaoGerar" v-if="relatorios">
                            <button @click="filtrar(true)" class="btn-filtrar" style="height: 40px;">Gerar</button>
                        </div>
                    </div>
                    <div class="divGerar" v-if="relatorios && usarExportacao">
                        <div class="botaoGerar" v-if="relatorios && usarExportacao">
                            <button @click="abrirModalExportacao()" class="btn-filtrar"
                                style="height: 40px;">Exportar</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <Modal v-if="state.mostrarModalExportacao" :mostrar="state.mostrarModalExportacao" :usarHeader="true" :usarFooter="true"
        @fechar="fecharModalExportacao" :usarCronometro="true">
        <template v-slot:header>
            <p>Selecione os relatórios para serem tirados</p>
        </template>
        <template v-slot:corpo>
            <div class="row">
                <label class="form-label">
                    <input type="checkbox" class="form-check-input" v-model="state.tirarRelatorios.tempoSetor">
                    Tempo Médio por Setor
                </label>
                <label class="form-label">
                    <input type="checkbox" class="form-check-input" v-model="state.tirarRelatorios.satisfacaoCliente">
                    Satisfação do Cliente
                </label>
                <label class="form-label">
                    <input type="checkbox" class="form-check-input" v-model="state.tirarRelatorios.atendimentoTempo">
                    Atendimento ao Longo do Tempo
                </label>
                <!-- <label class="form-label">
                    <input type="checkbox" class="form-check-input" v-model="state.tirarRelatorios.mediaEstrelasSetor">
                    Média de Estrelas por Setor
                </label> -->
                <label class="form-label">
                    <input type="checkbox" class="form-check-input" v-model="state.tirarRelatorios.historicoGeral">
                    Histórico Geral
                </label>
            </div>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-cancel" @click="fecharModalExportacao">Cancelar</button>
            <button class="btn btn-primary" @click="baixarRelatorios">Baixar</button>
        </template>
    </Modal>
    <Modal v-if="state.quantidadeRelatorios" :mostrar="state.quantidadeRelatorios" :usarHeader="true">
        <template v-slot:header>
            <p class="mb-0">Aguarde</p>
        </template>
        <template v-slot:corpo>
            <div class="d-flex justify-content-center" style="height: 130px;">
                <img src="../assets/gifs/greenloading.gif" alt="">
            </div>
            <p class="mb-0 mt-2">Relatórios concluidos: {{ state.relatoriosCompletos }} de {{ state.quantidadeRelatorios }}
            </p>
        </template>
    </Modal>
    <!-- data final grande
posicao grande

data final medio -->
</template>

<script setup>
import { RouterLink } from 'vue-router';
import _versao from '@/../package.json';
import FiltroTipoChamado from './FiltroTipoChamado.vue';
import store from '@/store/store';
import moment from 'moment';
import router from '@/roteador/indexRoteador';
import { reactive, defineProps, defineEmits, onMounted, computed, ref } from 'vue';
import Modal from '@/components/ModalEditar.vue';
import api from '@/api/api';
import { baseUrl } from "../api/const";

const props = defineProps(['principal', 'iniciadoPrincipal', 'usarAberto', 'usarHistorico', 'usarVoltar', 'usarDeslogar',
    'usarInternacao', 'usarFiltroTempo', 'relatorios', 'usarGerenciar', 'usarRelatorio', 'usarRelatorioEstrela',
    'usarRelatorioEstrelaAtend', 'usarFiltros', 'usarFiltroSetor', 'usarFiltroTpChamado', 'usarFiltroPosicao',
    'usarFiltroDatas', 'usarTrocaVisualizacao', 'pValorFiltroSetor', 'pValorFiltroTpChamado',
    'pValorFiltroPosicao', 'usarFiltroPosicaoAuxiliar', 'usarAlterarRelatorio', 'formatarDataInicioMes',
    'nomeTela', 'card', 'tabela', 'grafico', 'visualizacaoPadrao', 'usarExportacao']);

const emits = defineEmits(['filtrar', 'exportToPDF', 'resetarTela']);

const state = reactive({
    versao: _versao.version,
    valorFiltroSetor: Number(),
    valorFiltroTPChamado: Number(),
    // valorFiltroPosicao: String(),
    // valorFiltroPosicaoAuxiliar: String(),
    usarPosicaoAberto: Boolean(),
    usarPosicaoAdministrativo: Boolean(),
    usarPosicaoFechado: Boolean(),
    usarPosicaoCancelado: Boolean(),
    valorVisualizacao: String(),
    valorDuracao: String(0),
    dataInicial: new Date(),
    dataFinal: new Date(),
    historico: Boolean(),
    mostrarModalExportacao: Boolean(),
    exportacao: String(),
    tirarRelatorios: {
        tempoSetor: Boolean(),
        satisfacaoCliente: Boolean(),
        atendimentoTempo: Boolean(),
        mediaEstrelasSetor: Boolean(),
        historicoGeral: Boolean(),
    },
    relatoriosCompletos: Number(),
    quantidadeRelatorios: Number(),
});

onMounted(() => {
    iniciar();
    state.dataInicial = props.formatarDataInicioMes(state.dataInicial);
    state.dataInicial = moment(state.dataInicial).format("YYYY-MM-DD");
    state.dataFinal = moment(state.dataFinal).format("YYYY-MM-DD");
    state.valorVisualizacao = props.visualizacaoPadrao;
});

function iniciar() {
    if (props.principal) {
        setTimeout(() => {
            let path = window.location.href;
            let aux;
            if (window.location.href.search("/") != -1) {
                aux = path.search(",");
                if (aux == -1) {
                    let aux;
                    aux = localStorage.getItem("ValorFiltroSetor");
                    (aux) ? state.valorFiltroSetor = aux : state.valorFiltroSetor = 0;

                    aux = localStorage.getItem("ValorFiltroChamado");
                    (aux) ? state.valorFiltroTPChamado = aux : state.valorFiltroTPChamado = 0;
                } else {
                    state.valorFiltroSetor = path[aux - 1];
                    state.valorFiltroTPChamado = path[aux + 1];
                    localStorage.setItem('ValorFiltroSetor', state.valorFiltroSetor);
                    localStorage.setItem('ValorFiltroChamado', state.valorFiltroTPChamado);
                    path = path.replace(",", "");
                }
            }
        }, 1000);
    }
}

function filtrar(pAtualizar) {
    let tocar = false;
    let atualizar = pAtualizar;
    if (props.principal) {
        localStorage.setItem('ValorFiltroSetor', state.valorFiltroSetor);
        localStorage.setItem('ValorFiltroChamado', state.valorFiltroTPChamado);
        tocar = true;
        atualizar = true;
    }
    if (atualizar == true) {
        emits('filtrar', tocar, state.valorFiltroSetor, state.valorFiltroTPChamado, state.dataInicial,
            state.dataFinal, state.valorVisualizacao, state.valorDuracao, state.usarPosicaoAberto,
            state.usarPosicaoAdministrativo, state.usarPosicaoFechado, state.usarPosicaoCancelado);
        alterarVisualizacao();
    }
}

function alterarVisualizacao() {
    let alterada = false;
    if (state.historico == true && state.valorVisualizacao == 'Grafico') {
        state.valorVisualizacao = 'Card';
        alterada = true;
    }
    if (state.historico == false && state.valorVisualizacao == 'Card') {
        state.valorVisualizacao = 'Grafico';
        alterada = true;
    }
    emits('alterarVisualizacaoHistorico', state.historico, false, state.valorFiltroSetor,
        state.valorFiltroTPChamado, state.dataInicial, state.dataFinal, state.valorVisualizacao,
        state.valorDuracao, state.usarPosicaoAberto, state.usarPosicaoAdministrativo,
        state.usarPosicaoFechado, state.usarPosicaoCancelado);
}

function voltar() {
    (router.currentRoute.value.path == "/login") ? router.replace(router.options.routes[0].path) : router.back();
}

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    sessionStorage.removeItem("TokenDuracaoPainel");
    location.reload();
}

function exportacaoDeDados() {
    if (state.exportacao == "PDF")
        state.mostrarModalExportacao = true;
}

function fecharModalExportacao() {
    state.mostrarModalExportacao = false;
    state.tirarRelatorios = {
        tempoSetor: Boolean(),
        satisfacaoCliente: Boolean(),
        atendimentoTempo: Boolean(),
        mediaEstrelasSetor: Boolean(),
        historicoGeral: Boolean(),
    };
    state.exportacao = String();
}

async function baixarRelatorios() {
    // emits('exportToPDF', state.exportacao, state.tirarRelatorios);
    // console.log(state.tirarRelatorios);
    state.relatoriosCompletos = 0;
    if (state.tirarRelatorios.tempoSetor) { state.quantidadeRelatorios = state.quantidadeRelatorios + 1; }
    if (state.tirarRelatorios.satisfacaoCliente) { state.quantidadeRelatorios = state.quantidadeRelatorios + 1; }
    if (state.tirarRelatorios.atendimentoTempo) { state.quantidadeRelatorios = state.quantidadeRelatorios + 1; }
    if (state.tirarRelatorios.historicoGeral) { state.quantidadeRelatorios = state.quantidadeRelatorios + 1; }

    if (state.tirarRelatorios.tempoSetor) {
        await api.GerarRelatorioAtendimentoAoLongoTempo(state.dataInicial, state.dataFinal, state.valorDuracao, state.valorFiltroTPChamado, state.valorFiltroSetor).then(resp => {
            window.open(`${baseUrl}/Arquivos/${resp}`);
            state.relatoriosCompletos = state.relatoriosCompletos + 1;
        });
    }
    if (state.tirarRelatorios.satisfacaoCliente) {
        await api.GerarRelatorioSatisfacaoCliente(state.dataInicial, state.dataFinal, state.valorDuracao, state.valorFiltroTPChamado, state.valorFiltroSetor).then(resp => {
            window.open(`${baseUrl}/Arquivos/${resp}`);
            state.relatoriosCompletos = state.relatoriosCompletos + 1;
        });
    }
    if (state.tirarRelatorios.atendimentoTempo) {
        await api.GerarRelatorioTempoAtendimento(state.dataInicial, state.dataFinal, state.valorDuracao, state.valorFiltroTPChamado, state.valorFiltroSetor).then(resp => {
            window.open(`${baseUrl}/Arquivos/${resp}`);
            state.relatoriosCompletos = state.relatoriosCompletos + 1;
        });
    }
    if (state.tirarRelatorios.historicoGeral) {
        await api.GerarRelatorioHistoricoGeral(state.dataInicial, state.dataFinal, state.valorDuracao, state.valorFiltroTPChamado, state.valorFiltroSetor).then(resp => {
            window.open(`${baseUrl}/Arquivos/${resp}`);
            state.relatoriosCompletos = state.relatoriosCompletos + 1;
        });
    }

    state.quantidadeRelatorios = 0;
    fecharModalExportacao();
}

function resetarTela() {
    emits('resetarTela');
}

function abrirModalExportacao() {
    state.mostrarModalExportacao = true;
}

const setores = computed(() => {
    return store.state.setores;
});

const config = computed(() => {
    return store.state.config;
});

const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});

const token = computed(() => {
    return (sessionStorage.TokenReguaPainel) ? true : false;
});
</script>

<style scoped>
/*#region*/
p {
    margin-bottom: 0;
    margin-top: 2px;
}

label {
    margin-right: 5px;
}

span {
    font-size: 35px;
}

.form-select {
    width: 100%;
    max-width: 700px;
    border: 3px solid #006f45;
    border-left: none;
    text-align: center;
    border-radius: 0 5em 5em 0;
    color: #FFFFFF;
    background-color: #007d4d;
}

.navbar-toggler-icon {
    display: none;
}

.meuCollapse {
    background-color: var(--corNav);
    border: none;
    border-radius: 0;
    flex-direction: row;
    justify-content: space-evenly;
}

.hamburguer {
    display: block;
    background-color: var(--corNav);
}

.logo {
    height: 50px;
    width: 140px;
}

.nomeTela {
    font-size: 1.3em;
    text-transform: uppercase;
}

.clienteNome,
.nav-link,
.lblTelaMenor {
    color: #FFFFFF;
    font-size: 1.2em;
}

.lblTelaMenor {
    width: 10%;
    text-align: center;
    margin-right: -0.1%;
    border: 3px solid #006f45;
    border-radius: 5em 0 0 5em;
    border-right: none !important;
    color: #FFFFFF;
    background-color: #007d4d;
}

.nav-link {
    margin-left: 2%;
    width: 12%;
    text-align: center;
    border: 3px solid #006f45;
    border-radius: 5em;
    color: #FFFFFF;
    background-color: #007d4d;
}

.historico {
    margin-left: 5%;
}

.links {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 40px;
}

.historico,
.abertos {
    width: 150px;
    height: auto;
}

.divChamado,
.divSetor {
    display: flex;
    flex-direction: row;
    height: 40px;
    width: auto;
    justify-content: center;
}

.chamado {
    width: 65%;
}

.posicao {
    width: 30%;
}

.form-setor,
.form-chamado {
    width: 100%;
}

.filtros {
    display: flex;
}

.dataFinalGrande {
    display: flex !important;
}

.dataFinalPequeno {
    display: none !important;
}

.dataFinalCelular {
    display: none !important;
}

.divPosicaoGrande {
    display: flex !important;
}

.divPosicaoPequeno {
    display: none !important;
}

.btn-filtrar {
    color: white;
    border: 3px solid #006f45;
    background-color: #007d4d;
    border-radius: 5em;
    width: 85px;
}

.btn-filtrar:hover {
    color: black;
    border: 3px solid #006f45;
    background-color: #007d4d;
    border-radius: 5em;
}

.divGerar {
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

/*
    .divChamado :hover,
    .divSetor :hover {
        border-color: #005a38;
    }
*/

.margem1 {
    margin-left: 0.5%;
}

.margem2 {
    margin-left: 1%;
}

.margem3 {
    margin-left: 1.5%;
}

.margem4 {
    margin-left: 2%;
}

/*#endregion*/
.btnGerarPequeno {
    display: none;
}

.btnGerarGrande {
    display: block;
}

.posicaoGrande {
    width: 720px !important;
}

@media only screen and (max-width: 500px) {
    .clienteNome {
        display: none;
    }
}

@media only screen and (max-width : 900px) {
    label p {
        margin-bottom: 0;
        font-size: 1.2rem;
    }

    .mainFiltros {
        flex-direction: column !important;
    }

    .lblTelaMenor {
        width: 150px;
    }

    .links,
    .divSetor,
    .divChamado {
        margin-bottom: 1%;
    }

    .clienteNome {
        width: auto;
    }

    .botaoGerar {
        display: flex;
        align-self: center !important;
    }

    div .dataFinalPequeno {
        display: none !important;
    }

    .dataFinalCelular {
        display: flex !important;
    }

    .divGerar {
        margin-left: 0 !important;
    }

    .btnGerarGrande {
        display: none;
    }

    .btnGerarPequeno {
        display: block;
    }

}

@media only screen and (min-width : 901),
(max-width : 1000px) {

    .card-body {
        padding-left: 0;
        padding-right: 0;
    }

    .collapsed {
        display: flex;
    }

    .navbar-toggler-icon {
        display: block;
    }

    span {
        font-size: 35px;
    }

    .hamburguer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .clienteNome {
        color: #FFFFFF;
        text-align: center;
        font-size: 1.2em;
        /*margin-bottom: 0;
        font-size: 30px !important;
        margin-top: 1.5%;*/
        width: auto;
    }

    .nav-link {
        margin-left: 0;
    }

    .form-select {
        min-width: 220px;
        width: auto;
    }

    .meuCollapse {
        flex-direction: column;
    }

    .links,
    .divSetor,
    .divChamado {
        width: 100%;
        justify-content: center;
        margin-bottom: 1%;
    }

    .links {
        justify-content: space-evenly;
    }

    label p {
        margin-bottom: 0;
        font-size: 1.2rem;
    }

    .lblTelaMenor {
        width: 200px !important;
    }

    .hamburguer-principal {
        justify-content: space-between;
    }

    .filtros,
    .mainFiltros {
        width: 100% !important;
    }

    .botaoGerar {
        display: flex;
        justify-content: center !important;
    }

    .btn-filtrar {
        width: 150px;
        /*width: 100%;*/
    }

    .posicaoGrande {
        width: 100% !important;
    }
}

@media only screen and (min-width: 901px) and (max-width: 1660px) {

    /* esse */
    .dataFinalGrande {
        display: none !important;
    }

    .dataFinalPequeno {
        display: none !important;
    }

    .dataFinalCelular {
        display: none !important;
    }

    .divPosicaoGrande {
        display: flex !important;
    }

    .divPosicaoPequeno {
        display: none !important;
    }

    .divVisualizacao {
        margin-top: 0.3%;
    }

    .btnGerarPequeno {
        display: block;
    }

    .btnGerarGrande {
        display: none;
    }

}

@media only screen and (max-width : 1660px) {
    .filtros {
        flex-direction: column !important;
    }

    .lblTelaMenor,
    .posicao {
        width: 126px;
    }

    .clienteNome {
        min-width: 200px !important;
        text-align: left !important;
        /*padding: 0;
        margin: 0;*/
    }

    .dataFinalGrande {
        display: none !important;
    }

    .dataFinalPequeno {
        display: flex !important;
    }

    .divPosicaoGrande {
        display: none !important;
    }

    .divPosicaoPequeno {
        display: flex !important;
    }

    .botaoGerar {
        display: flex;
        justify-content: center;
        margin-right: 0.2em;
        margin-top: 0.3%;
    }

    .btn-filtrar {
        height: 100%;
        width: 150px;
    }

    .margem1 {
        margin-left: 0;
    }

    .margem2 {
        margin-left: 0;
    }

    .margem3 {
        margin-left: 0;
    }

    .margem4 {
        margin-left: 0;
    }
}

@media only screen and (min-width : 1001px),
(max-width : 1499) {

    .divChamado,
    .divSetor {
        display: flex;
        width: 360px;
        flex-direction: row;
    }

    .meuCollapse {
        justify-content: space-evenly;
    }

    .collapsed {
        display: none;
    }

    label p {
        margin-bottom: 0;
        font-size: 1.1rem;
    }

    .filtros,
    .mainFiltros {
        flex-direction: row;
    }

    .collapse {
        display: block !important;
    }

    .clienteNome {
        width: 200px;
        min-width: 400px !important;
        text-align: left;
        /*padding: 0;
        margin: 0;*/
    }

    .hamburguer-principal {
        justify-content: space-around;
    }
}

@media only screen and (min-width : 1500px) {
    .lblTelaMenor {
        /*margin-right: -6%;*/
        text-align: center;
        max-width: auto;
    }

    .divChamado,
    .divSetor {
        display: flex;
        flex-direction: row;
    }

    .clienteNome {
        min-width: 400px !important;
        padding: 0;
        text-align: left;
    }
}
</style>